<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">
		
	
		<div class="">
			<el-form inline ref="form" :model="searchform">
       
       
       <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value3" :placeholder="$t('searchText.구분')" size="mini" style="width:100px">
               <el-option
                      v-for="item in searchform.searchOptions3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>

				<el-form-item class="mb-0 mr-0">
						 <el-select v-model="searchform.value2" :placeholder="$t('searchText.상태선택')" size="mini" style="width:100px;">
						   <el-option
								      v-for="item in searchform.searchOptions2"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
						  </el-select>
					</el-form-item>

          

					<el-form-item class="mb-0 mr-0">
						 <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:120px;">
						   <el-option
								      v-for="item in searchform.searchOptions"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
						  </el-select>
					</el-form-item>


					<el-form-item class="mb-0 mr-0">
						 <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
					</el-form-item>

           <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value4" multiple :placeholder="$t('msg.레벨선택')" size="mini">
               <el-option
                      v-for="item in searchform.searchOptions4"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>

          
					<el-form-item  class="mb-0" style="margin-right:0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd"style="width:200px" >
						    </el-date-picker>
					</el-form-item>
					<el-form-item class="mb-0 mr-0">
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
             <el-button type="success" size="mini" icon="el-icon-document-delete" @click="exportExcel" :disabled = "disabled">{{$t('searchText.엑셀다운')}}</el-button> 
             
					</el-form-item>
			</el-form>
       
		
		</div>
	
	</div>
    <div class="text-muted mt-2">

      <span class="text-danger ml-2">{{$t('searchText.입금계')}}:{{formatMoney(total_money)}}</span><span class="text-primary ml-2">{{$t('searchText.출금계')}}:{{formatMoney(total_emoney)}}</span><span class="text-success ml-2">{{$t('searchText.차액')}}:{{formatMoney(total_money-total_emoney)}}</span>
 <span class="text-danger ml-2">{{$t('searchText.입금계')}}:{{formatMoney(utotal_money)}}</span><span class="text-primary ml-2">{{$t('searchText.출금계')}}:{{formatMoney(total_uemoney)}}</span><span class="text-success ml-2">{{$t('searchText.차액')}}:{{formatMoney(utotal_money-utotal_emoney)}}</span>
    </div>
       <el-tabs v-model="activeName" @tab-click="handleClick" type="card" class="mt-2">
        


        <el-tab-pane :label="$t('msg.전체')" name="first">
         <el-button type="danger" size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :row-class-name="tableRowClassName"  @selection-change="handleSelectionChange" 
        :highlight-current-row="true"
       :empty-text="$t('tableText.데이타가없습니다')">
       <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column>
  <el-table-column width="50" align="center" label="ID">
    
     
  
          <template v-if="loading==false" slot-scope="scope"> <el-tooltip class="item" effect="dark" :content="scope.row.io_idx" placement="top-end"><el-button type="text">{{total-(currentPage-1)*30-scope.$index}}</el-button></el-tooltip></template>
        </el-table-column>


<el-table-column
        v-if="this.multi_site=='1'"
        label="사이트" prop="sitename" align="center" >
        
      </el-table-column> 


      <el-table-column
        
        :label="$t('searchText.구분')" prop="io_type" align="center" width="100">
         <template slot-scope="scope">
              <span :class="scope.row.io_type ==='1' ?'text-danger':'text-primary'">{{iotypeObj[scope.row.io_type]}}</span>
             
          </template>
      </el-table-column>
       <el-table-column
        :label="$t('nav.아이디')" prop="io_id" align="center" width="100">
          <template slot-scope="scope">
            <div :style="{ backgroundColor: (userid === 'soft16' || userid === 'soft23') ? (String(scope.row.memState) === '1' ? '#d1fae5' : String(scope.row.memState) === '4' ? '#dbeafe' : scope.row.RaceYN) : scope.row.RaceYN }">
             <span @click="openModel(scope.row.io_id)" class="text-primary" style="cursor:pointer;">{{scope.row.io_id}}</span>
           </div>
          </template>
      </el-table-column> 

      <el-table-column
      :label="$t('tableText.이름')"

        prop="io_in_name" align="center">
          <template slot-scope="scope">
            
             <span @click="bonOpen(1,scope.row.io_id)"  style="cursor:pointer">{{scope.row.io_in_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})</span>
          </template>
      </el-table-column> 

         <el-table-column
        :label="$t('tableText.예금주')"
         prop="io_name" align="center">
      </el-table-column>
    
  <template v-if="this.sitetype==='1' || this.sitetype==='3'">
      <el-table-column
         :label="$t('tableText.부본사총판추천인')"
       prop="b_code" align="center">
        <template slot-scope="scope">
          {{scope.row.b_code}}-{{scope.row.a_code}}-{{scope.row.m_cp}}
        </template>
      </el-table-column>
    </template>
    <template v-if=" this.sitetype==='4'">

      <el-table-column
          :label="$t('tableText.부본사총판매장')"
         prop="b_code" align="center">
        <template slot-scope="scope">
          {{scope.row.b_code}}-{{scope.row.a_code}}-{{scope.row.c_code}}
        </template>
      </el-table-column>
    </template>

     
       <el-table-column
         :label="$t('msg.입금금액')"
        prop="io_money" align="center">
        <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.io_money)}}   </span>
          <template v-if="scope.row.io_money_usdt!=0 && userid=='diamond'">
      <br>usdt: {{ scope.row.io_money_usdt }}
    </template> </template>

      </el-table-column>

      <el-table-column
         :label="$t('msg.출금금액')"
        prop="io_out_money" align="center">
        <template slot-scope="scope"><span class="text-danger">{{ formatMoney(scope.row.io_out_money)}}   </span>
<template v-if="scope.row.io_out_money_usdt!=0   && userid=='diamond'">
      <br>usdt: {{ scope.row.io_out_money_usdt }}
    </template>
      </template>

      </el-table-column>
     
        <el-table-column
         :label="$t('tableText.신청시잔액')"
         prop="io_jan" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.io_jan)}}</template>

      </el-table-column>

      <el-table-column
         :label="$t('tableText.현잔액')"
       prop="mem_cash" align="center">
        <template slot-scope="scope">{{ scope.row.mem_cash>0 ? formatMoney(scope.row.mem_cash):formatMoney(scope.row.api_money) }}</template>


      </el-table-column>

      <el-table-column
         :label="$t('tableText.오늘입금')"
       prop="mem_cash" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.t_in)}}</template>

      </el-table-column>
      
     <el-table-column
         :label="$t('tableText.신청시간')"
       prop="io_regdate" align="center">
      </el-table-column>
    
     <el-table-column
         :label="$t('tableText.아이피')"
       prop="sip" align="center">
      </el-table-column>
     
      <el-table-column
         :label="$t('nav.이벤트')"
        align="center"  width="120" prop="io_see">
        <template slot-scope="scope" v-if="scope.row.io_type=='1' && (scope.row.io_sangte==1 || scope.row.io_sangte==2)"><el-checkbox  true-label="1" false-label="0" v-model="scope.row.io_see"></el-checkbox></template>
        <template slot-scope="scope" v-if="scope.row.point_>0">{{ formatMoney(scope.row.point_)}}</template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="io_sangte"
            width="110"
           :label="$t('tableText.상태')"
         >
          <template slot-scope="scope">
          <el-select :placeholder="$t('status.선택')" v-model="scope.row.io_sangte" size="mini" @change="changeOptions(scope)" :class="iconObj[scope.row.io_sangte]">
              <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :disabled="item.disabled"
              :value="item.value">
            </el-option>
            </el-select>
      </template>
          </el-table-column>


          <el-table-column
           align="center"
          prop="io_sangte"
          width="240">
         
          <template slot-scope="scope">
         
        <template v-if="scope.row.io_type=='1'">
            <el-button v-if="scope.row.io_sangte=='1' || scope.row.io_sangte=='2'" type="primary" size="mini" style="margin-left:0" @click="infoOpen(scope)" :loading="btnLoad">{{$t('msg.입금')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2') && sitetype=='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2' || scope.row.io_sangte=='3') && sitetype!='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button>
           </template>


 <template v-if="scope.row.io_type=='2'">
              <el-button v-if="scope.row.io_sangte=='1' || scope.row.io_sangte=='2'" type="primary" size="mini" style="margin-left:0" @click="infoOpen(scope)" :loading="btnLoad">{{$t('msg.출금')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2') && sitetype=='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2' || scope.row.io_sangte=='3') && sitetype!='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button>  </template>



         </template>

      
         
         
          
      


          </el-table-column>
    
      
  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
          <div style="flex: 1;" class="px-2">
            <el-pagination
            :current-page="currentPage"
            :page-sizes="[30,50,100]"
            :page-size="this.size"
            layout="sizes,prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
          </el-pagination>
          </div>
        </el-footer>  
        </el-tab-pane>


        <el-tab-pane :label="$t('msg.입금')" v-if="this.sitetype==4" name="second">
          
 <el-button type="danger" size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>
  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :row-class-name="tableRowClassName"  @selection-change="handleSelectionChange" 
      :empty-text="$t('tableText.데이타가없습니다')">
      <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
  <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*20-scope.$index}}</template>
        </el-table-column>

<el-table-column
        v-if="this.multi_site=='1'"
        label="사이트" prop="sitename" align="center" >
        
      </el-table-column> 
      <el-table-column
        
        :label="$t('searchText.구분')" prop="io_type" align="center" width="100">
         <template slot-scope="scope">
              <span :class="scope.row.io_type ==='1' ?'text-danger':'text-primary'">{{iotypeObj[scope.row.io_type]}}</span>
             
          </template>
      </el-table-column>
       <el-table-column
        :label="$t('nav.아이디')" prop="io_id" align="center" width="100">
          <template slot-scope="scope">
            <div :style="{ backgroundColor: (userid === 'soft16' || userid === 'soft23') ? (String(scope.row.memState) === '1' ? '#d1fae5' : String(scope.row.memState) === '4' ? '#dbeafe' : scope.row.RaceYN) : scope.row.RaceYN }">
             <span @click="openModel(scope.row.io_id)" class="text-primary" style="cursor:pointer;">{{scope.row.io_id}}</span>
           </div>
          </template>
      </el-table-column> 

      <el-table-column
       :label="$t('tableText.이름')"
       prop="io_in_name" align="center">
          <template slot-scope="scope">
            
             <span @click="bonOpen(1,scope.row.io_id)"  style="cursor:pointer">{{scope.row.io_in_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})</span>
          </template>
      </el-table-column> 

     
    
  <template v-if="this.sitetype==='1' || this.sitetype==='2' || this.sitetype==='3'">
      <el-table-column
        :label="$t('tableText.부본사총판추천인')"
        prop="b_code" align="center">
        <template slot-scope="scope">
          {{scope.row.b_code}}-{{scope.row.a_code}}-{{scope.row.m_cp}}
        </template>
      </el-table-column>
    </template>
    <template v-else>
      <el-table-column
         :label="$t('tableText.부본사총판매장')"
        prop="b_code" align="center">
        <template slot-scope="scope">
          {{scope.row.b_code}}-{{scope.row.a_code}}-{{scope.row.c_code}}
        </template>
      </el-table-column>
    </template>

     
         <el-table-column
         :label="$t('msg.입금금액')"
        prop="io_money" align="center">
        <template slot-scope="scope"><span class="text-danger">{{ formatMoney(scope.row.io_money)}}   </span>
          <template v-if="scope.row.io_money!=0 && scope.row.io_maybe !== ''">
      <br>usdt: {{ scope.row.io_maybe }}
    </template> </template>

      </el-table-column>

      <el-table-column
         :label="$t('msg.출금금액')"
        prop="io_out_money" align="center">
        <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.io_out_money)}}   </span>
     
     <template v-if="scope.row.io_out_money !=0 && scope.row.io_maybe !== ''">
      <br>usdt: {{ scope.row.io_maybe }}
    </template>
      </template>

      </el-table-column>
     
        <el-table-column
        :label="$t('tableText.신청시잔액')"
      prop="io_jan" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.io_jan)}}</template>

      </el-table-column>

      <el-table-column
          :label="$t('tableText.현잔액')"
        prop="mem_cash" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>

      </el-table-column>
      
     <el-table-column
          :label="$t('tableText.신청시간')"
       prop="io_regdate" align="center">
      </el-table-column>
    
     <el-table-column
          :label="$t('tableText.아이피')"
       prop="sip" align="center">
      </el-table-column>

      <el-table-column
           align="center"
             width="110"
          prop="io_sangte"
          :label="$t('tableText.상태')"
        >
          <template slot-scope="scope">
          <el-select :placeholder="$t('status.선택')" v-model="scope.row.io_sangte" size="mini" @change="changeOptions(scope)" :class="iconObj[scope.row.io_sangte]">
              <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :disabled="item.disabled"
              :value="item.value">
            </el-option>
            </el-select>
      </template>
          </el-table-column>
            <el-table-column
           align="center"
          prop="io_sangte"
          width="240">
         
          <template slot-scope="scope">
         
        <template v-if="scope.row.io_type=='1'">
            <el-button v-if="scope.row.io_sangte=='1' || scope.row.io_sangte=='2'" type="primary" size="mini" style="margin-left:0" @click="infoOpen(scope)" :loading="btnLoad">{{$t('msg.입금')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2') && sitetype=='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2' || scope.row.io_sangte=='3') && sitetype!='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button>
           </template>


 <template v-if="scope.row.io_type=='2'">
              <el-button v-if="scope.row.io_sangte=='1' || scope.row.io_sangte=='2'" type="primary" size="mini" style="margin-left:0" @click="infoOpen(scope)" :loading="btnLoad">{{$t('msg.출금')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2') && sitetype=='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2' || scope.row.io_sangte=='3') && sitetype!='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button>  </template>



         </template>

      
         
         
          
      


          </el-table-column>
    
      
  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
          <div style="flex: 1;" class="px-2">
            <el-pagination
            :current-page="currentPage"
            :page-sizes="[30,50,100]"
            :page-size="this.size"
            layout="sizes,prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
          </el-pagination>
          </div>
        </el-footer>  
        </el-tab-pane>
        <el-tab-pane :label="$t('msg.출금')" v-if="this.sitetype==4"  name="three">
           <el-button type="danger" size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :row-class-name="tableRowClassName"  @selection-change="handleSelectionChange"
      :empty-text="$t('tableText.데이타가없습니다')">
  <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column>   <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*20-scope.$index}}</template>
        </el-table-column>


      
      <el-table-column
      v-if="this.multi_site=='1'"
        label="사이트"  prop="sitename" align="center" >  
      </el-table-column> 

      

      <el-table-column
        
        :label="$t('searchText.구분')" prop="io_type" align="center" width="100">
         <template slot-scope="scope">
              <span :class="scope.row.io_type ==='1' ?'text-danger':'text-primary'">{{iotypeObj[scope.row.io_type]}}</span>
             
          </template>
      </el-table-column>
       <el-table-column
        :label="$t('nav.아이디')" prop="io_id" align="center" width="100">
          <template slot-scope="scope">
            <div :style="{ backgroundColor: (userid === 'soft16' || userid === 'soft23') ? (String(scope.row.memState) === '1' ? '#d1fae5' : String(scope.row.memState) === '4' ? '#dbeafe' : scope.row.RaceYN) : String(scope.row.memState) === '4' ? '#d1fae5' : scope.row.RaceYN }">
             <span @click="openModel(scope.row.io_id)" class="text-primary" style="cursor:pointer;">{{scope.row.io_id}}</span>
           </div>
          </template>
      </el-table-column> 

      <el-table-column
        :label="$t('tableText.이름')" prop="io_in_name" align="center">
          <template slot-scope="scope">
            
             <span @click="bonOpen(1,scope.row.io_id)"  style="cursor:pointer">{{scope.row.io_in_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})</span>
          </template>
      </el-table-column> 

     
    
  <template v-if="this.sitetype==='1' || this.sitetype==='2' || this.sitetype==='3'">
      <el-table-column
        :label="$t('tableText.부본사총판추천인')" 
         prop="b_code" align="center">
        <template slot-scope="scope">
          {{scope.row.b_code}}-{{scope.row.a_code}}-{{scope.row.m_cp}}
        </template>
      </el-table-column>
    </template>
    <template v-else>
      <el-table-column
        :label="$t('tableText.부본사총판매장')"
        prop="b_code" align="center">
        <template slot-scope="scope">
          {{scope.row.b_code}}-{{scope.row.a_code}}-{{scope.row.c_code}}
        </template>
      </el-table-column>
    </template>

     
            <el-table-column
         :label="$t('msg.입금금액')"
        prop="io_money" align="center">
        <template slot-scope="scope"><span class="text-danger">{{ formatMoney(scope.row.io_money)}}   </span>
          <template v-if="scope.row.io_money!=0 && scope.row.io_maybe !== ''">
      <br>usdt: {{ scope.row.io_maybe }}
    </template> </template>

      </el-table-column>

      <el-table-column
         :label="$t('msg.출금금액')"
        prop="io_out_money" align="center">
        <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.io_out_money)}}   </span>
<template v-if="scope.row.io_out_money
!=0 && scope.row.io_maybe !== ''">
      <br>usdt:{{ scope.row.io_maybe }}
    </template>
      </template>

      </el-table-column>
     
        <el-table-column
        :label="$t('tableText.신청시잔액')"
       prop="io_jan" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.io_jan)}}</template>

      </el-table-column>

      <el-table-column
        :label="$t('tableText.현잔액')"
        prop="mem_cash" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>

      </el-table-column>
      
     <el-table-column
        :label="$t('tableText.신청시간')"
      prop="io_regdate" align="center">
      </el-table-column>
    
     <el-table-column
          :label="$t('tableText.아이피')"
     prop="sip" align="center">
      </el-table-column>

      <el-table-column
           align="center"
           width="110"
          prop="io_sangte"
          :label="$t('tableText.상태')"
         >
          <template slot-scope="scope">
          <el-select :placeholder="$t('status.선택')" v-model="scope.row.io_sangte" size="mini" @change="changeOptions(scope)" :class="iconObj[scope.row.io_sangte]">
              <el-option
              v-for="item in options"
              :key="item.value"
              :disabled="item.disabled"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
      </template>
          </el-table-column>
            <el-table-column
           align="center"
          prop="io_sangte"
          width="240">
         
          <template slot-scope="scope">
         
        <template v-if="scope.row.io_type=='1'">
            <el-button v-if="scope.row.io_sangte=='1' || scope.row.io_sangte=='2'" type="primary" size="mini" style="margin-left:0" @click="infoOpen(scope)" :loading="btnLoad">{{$t('msg.입금')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2') && sitetype=='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2' || scope.row.io_sangte=='3') && sitetype!='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button>
           </template>


 <template v-if="scope.row.io_type=='2'">
              <el-button v-if="scope.row.io_sangte=='1' || scope.row.io_sangte=='2'" type="primary" size="mini" style="margin-left:0" @click="infoOpen(scope)" :loading="btnLoad">{{$t('msg.출금')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2') && sitetype=='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2' || scope.row.io_sangte=='3') && sitetype!='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button>  </template>



         </template>

      
         
         
          
      


          </el-table-column>
    
      
  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
          <div style="flex: 1;" class="px-2">
            <el-pagination
            :current-page="currentPage"
            :page-sizes="[30,50,100]"
            :page-size="this.size"
            layout="sizes,prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
          </el-pagination>
          </div>
        </el-footer>  
        </el-tab-pane>
       </el-tabs>

    <el-dialog
  title=""
  :visible.sync="infoOpendialogVisible"
  width="800px"
  class="custom-dialog"
  >
  <div class="dialog-content">
   
  <el-table
    :data="infoData"
    border
 v-loading="infoloading"
    style="width: 100%;margin-top: 20px;">
    <el-table-column
      prop="io_id"
      label="아이디"  align="center">
    </el-table-column>
   
      
      <el-table-column prop="io_money"  label="입금액"  align="center">
           <template slot-scope="scope">{{ formatMoney(scope.row.io_money)}}</template>
      </el-table-column>
      <el-table-column prop="io_out_money"  label="출금액"  align="center">
            <template slot-scope="scope">{{ formatMoney(scope.row.io_out_money)}}</template>
      </el-table-column>
      <el-table-column prop="io_regdate"  label="신청시간"  align="center">
        
         <template slot-scope="scope">{{ scope.row.io_regdate }}</template>
      </el-table-column>
    
  
  </el-table>
  <div :style="{color:infoMsgColor}" class="text-center mt-3"><span style="font-size: 15px">{{infoMsg}}</span></div>
</div>
 

  <span slot="footer" class="dialog-footer">
    <el-button @click="infoOpendialogVisible = false">취소</el-button>
    <el-button type="primary" :loading="infobtnLoad" @click="okBtn('')">확인</el-button>
  </span>
</el-dialog>
				
</div>
 </template>

 <script>
  //window.setTimeout('window.location.reload()',30000); //30초마다 새로고침
   import * as XLSX from 'xlsx/xlsx.mjs';
 import layer from '../../components/common/layer.vue';
import layoutLayer from '../../components/common/layout-layer.vue';
import layerNew from '../../components/common/layer-new.vue';
    export default {
     components: {
      layer,
      layoutLayer,
      layerNew
    },
    	data(){
    		return{
          io_idx:'',
          infoMsg:'',
          infoMsgColor:'',
          infoData:[],
          infobtnLoad:false,
          infoloading:false,
          infoOpendialogVisible:false,
           btnLoad:false,
          disabled:false,
          checked:'1',
          activeName: 'first',
          tapidx:"0",
          dWidth:'400px',
          io_type:'',
           ioType: [
               {
                label:this.$i18n.t("msg.충전"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.환전"),
                 value: '2',
               
              }],
          form:{
            mem_id:'',
            money:'',
            memo:'',
          },
           level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")             
            },
          domain:window.sessionStorage.getItem('domain'),
 sitetype:window.sessionStorage.getItem('sitetype'),
   bg:window.sessionStorage.getItem('bg'),
   userid:window.sessionStorage.getItem('userid'),
      aid:window.sessionStorage.getItem('admin_id'),
      multi_site:window.sessionStorage.getItem('multi_site'),
          formLoading:false,
          idDialogVisible: false,
          dialogModel:false,
          iconObj:{
              '1':'bg-primary',
              '2':'bg-danger',
              '3':'',
              '4':'bg-yellow',
          
             
            },
             iotypeObj:{
              '1':this.$i18n.t("msg.입금"),
              '2':this.$i18n.t("msg.출금"),
            },
             iotypeObj2:{
              '1':this.$i18n.t("msg.파워볼"),
              '2':this.$i18n.t("searchText.카슬"),
              '3':this.$i18n.t("nav.알잔액"),
            },
    			total_cash: '',
				total_ecash: '',
				total_emoney: '',
				total_money: '',
        options1: [{
               
                label: this.$i18n.t("msg.게임머니"),
                 value: '1',
               
              }],

    			options: [{
	              label:this.$i18n.t("msg.대기") ,
                value: '1',
                disabled:false
               
              }, {
                label: this.$i18n.t("msg.처리중"),
                 value: '2',
                 disabled:false
                
              }, {
                label: this.$i18n.t("msg.완료"),
                 value: '3',
                 disabled:true
               
              }, {
                label: this.$i18n.t("msg.취소"),
                 value: '4',
                 //disabled:true
               
              }, {
                label: this.$i18n.t("msg.삭제"),
                 value: '5',
                 disabled:false
               
              }, {
                label: '상태만완료',
                 value: '6',
               
              }], 
    			searchform:{
    				keyword:'',
    				time:[],
    				searchOptions:[
               {
              label:this.$i18n.t("msg.아이디"),
              value:'io_id'
            },
            {
              label:this.$i18n.t("msg.닉네임"),
              value:'io_in_name'
            },
            {
              label:this.$i18n.t("msg.입금인"),
              value:'io_name'
            },
            {
              label:this.$i18n.t("msg.예금주"),
              value:'mem_bankname'
            },
		       
		        {
		        	label:'ip',
		        	value:'sip'
		        },
            
             {
              label:this.$i18n.t("msg.매장"),
              value:'c_code'
            },
            {
              label:this.$i18n.t("msg.총판"),
              value:'a_code'
            },
            {
              label:this.$i18n.t("msg.부본"),
              value:'b_code'
            },
            {
              label:this.$i18n.t("msg.알본"),
              value:'admin_id'
            },
 
           
           
           
		       

		        ],
		        searchOptions2:[
                
    				{
              label:this.$i18n.t("msg.전체"),
              value:''
            },{
              label:this.$i18n.t("msg.대기"),
              value:'1'
            },
            
            {
              label:this.$i18n.t("msg.처리중"),
              value:'2'
            },
            {
              label:this.$i18n.t("msg.완료"),
              value:'3'
            },
            {
              label:this.$i18n.t("msg.취소"),
              value:'4'
            },
		        ],
            searchOptions3:[
             {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.입금"),
              value:'1'
            },
            {
              label:this.$i18n.t("msg.출금"),
              value:'2'
            }
            ],
             searchOptions4:[
               
           
            {
             label:this.$i18n.t("msg.기본"),
              value:'0'
            },
            {
              label:'V1',
              value:'1'
            },
            {
              label:'V2',
              value:'2'
            },
            {
              label:'V3',
              value:'3'
            },
            {
              label:'V4',
              value:'4'
            },
            {
              label:'V5',
              value:'5'
            },
            {
              label:'V6',
              value:'6'
            },
            {
              label:'V7',
              value:'7'
            },
            {
              label:'co',
              value:'8'
            }       
            ],
            value4:[],
		        value:'',
		        value2:'',
            value3:'',


    			},
    			 pickerOptions: {
    			},
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
    
      		
		        
    		
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
			         currentPage:1,
			         multipleSelection:[],
			         superSearch:false,
               gubun:'',
			         
			 
    			}
    			
    			
    		},
        
    		created() {
        //  console.log('ccc')
          if(this.sitetype=="3")
        {
                this.options1=[{
               
               label: this.$i18n.t("msg.게임머니"),
                 value: '1',
               
              }, {
                label:this.$i18n.t("msg.이벤트머니"),
                 value: '2',
               
              }, {
                label:this.$i18n.t("msg.롤링머니"),
                 value: '3',
               
              }];
        }

         if(this.sitetype=="2" || this.sitetype=="4")
        {
                this.options1=[{
               
                label:this.$i18n.t("msg.게임머니"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.이벤트머니"),
                 value: '2',
               
               
              }];
        }

          let param_type=this.$route.params.io_type

          if (typeof(param_type) == "undefined")
          {

          }else
          {
              this.searchform.value3=param_type
          }

           const timer2 = window.setInterval(()=>{
             this.getList()
            }, 60000)
            
            this.$once('hook:beforeDestroy', function () {
               window.clearInterval(timer2)
            })
    			
          //console.log('route',this.$route.params.io_type)

    			this.getList();
    			
			
		},
    	
    	methods:{
          exportExcel() {
         let token=window.sessionStorage.getItem('user');
         this.disabled = true

         let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
               let user_type="";
               
               if(this.tapidx=='1')
               {
                  user_type="user";
               }
               if(this.tapidx=='2')
               {
                  user_type="pt";
               }

          
           let urls=this.domain+'/admin/moneylist?user_type='+user_type+'&level='+this.searchform.value4+'&excel=1&limit='+this.size+'&io_type='+this.searchform.value3+'&status='+this.searchform.value2+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;
          
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{

               if(response.data.code!=200)
               {
                 this.disabled = false
                   this.$message.error(response.data.msg);
                   return;
               }


               let data = response.data.data

                this.total = response.data.total


               let wopts = {
                  bookType: 'xlsx',
                  bookSST: true,
                  type: 'binary'
                };
                let workBook = {
                  SheetNames: ['Sheet1'],
                  Sheets: {},
                  Props: {}
                };

                let table =data
                this.disabled = false

      
 
      workBook.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(table);

      XLSX.utils.sheet_add_aoa(workBook.Sheets['Sheet1'], [["Created "+new Date().toISOString()]], {origin:-1});
      XLSX.writeFile(workBook, "money.xlsb");

      this.$message.success(this.$i18n.t("msg.엑셀저장완료"))

                     
                     // this.tableData =data.data
                    
               
            }).catch((error) =>{

               this.disabled = false
              
               this.$message.error(error);
              this.loading = false
               
            })
      
     

 
  
    },
     tableRowClassName({row, rowIndex}) {
     
       if (rowIndex%2 === 1) {
        return 'odd-row';
       }
       else{
         return 'edd-row';
       }
    },
        handleClick(tab, event) {
              //console.log(tab, event);
              this.tapidx=tab.index
              this.getList()
      },
       bonOpen(e,id){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layoutLayer,
                parent: this,
                data:{
                einfo:{e:e},
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['500px', '480px'],
        });
        
        },
      
        
         // 关闭弹框（头部的X）
        
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
         openModel(id){
          let pix=window.screen.width;
           
                let width='1080px';
                if(pix<1200)
                {
                  width='95%';
                }
          if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                area: [width+'', '700px'],
             
             });
              return;
           }
            let layerwidth='950px';
                if(pix<1200)
                {
                  layerwidth='95%';
                }
            this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: [layerwidth+'', '680px'],
         
        });
        },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }

              
            
this.currentPage=1;

    			this.getList();
    			
             

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			     
    		getList(){

    		   

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				

            let user_type="";
             
               if(this.tapidx=='1')
               {
                  //user_type="user";
                  this.searchform.value3="1"
               }
               if(this.tapidx=='2')
               {
                  //user_type="pt";
                  this.searchform.value3="2"
               }
               if(this.tapidx=='0')
               {
                  //user_type="user";
                  this.searchform.value3=""
               }

    			 let urls=this.domain+'/admin/moneylist?user_type='+user_type+'&level='+this.searchform.value4+'&limit='+this.size+'&io_type='+this.searchform.value3+'&status='+this.searchform.value2+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =parseInt(data.per_page)

                     //console.log('data=',data.per_page)

                     this.total_cash = response.data.total_cash
                     this.total_ecash = response.data.total_ecash
                     this.total_emoney = response.data.total_emoney
                     this.total_money = response.data.total_money

                     this.utotal_emoney = response.data.utotal_emoney
                     this.utotal_money = response.data.utotal_money

                     this.loading =false

                     if(response.data.arr!=null)
                     {
                        this.iotypeObj2=response.data.arr
                     }

                     
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
               
            })
    		},
          handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
       deleteAll(){
         this.$prompt(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          inputPlaceholder:'인증코드를입력하세요',
          type: 'warning'
        }).then(({value}) => {
          let token=window.sessionStorage.getItem('user');

          //console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            //console.log('id',item.idx);
            newids.push(item.sid);
           });

          // console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{
                        idx:newids,
                        otp:value
                     },
                      url:this.domain+'/admin/money_del_all',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },
      infoOpen(e){

         this.btnLoad = true
       
        let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                       data:{
                        io_idx:e.row.io_idx,
                      
                     },
                      url:this.domain+'/admin/money_up_check',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                     
                    if(response.data.code==200){
                        
                        this.infoData = response.data.data
                         this.btnLoad = false;

                        if(this.infoData.length==0)
                        {
                           // this.infoloading = false;
                           // this.infoOpendialogVisible = false;
                             
                            this.changeBtn(e,'3');
                            return;
                        }

                         this.infoOpendialogVisible = true;
                        // this.infoloading = true

                        this.infoMsg = response.data.msg
                        this.infoMsgColor = response.data.color
                        this.io_idx = response.data.io_idx

                        
                    }else
                    {

                      this.infoloading = false
                       this.btnLoad = false;
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                  }).catch((error) =>{
                     this.infoloading = false
                      this.btnLoad = false;
                     this.infoOpendialogVisible = false;
                     this.changeBtn(e,'3');
                  })




      },
       changeBtn(e,type){
            if(type=='4'){
               this.$prompt(this.$i18n.t("msg.취소하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.확인"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          inputPlaceholder: '쪽지로보낼내용입력',
          type: 'warning'
        }).then((value) => {
          let token=window.sessionStorage.getItem('user');
          this.btnLoad = true
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/money_up',
                       data:{
                       io_money:e.row.io_money,
                       status:type,
                       id:e.row.io_idx,
                       msg:value.value
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                    this.btnLoad = false
                    
                    if(response.data.code==200){
                      
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                       this.$router.replace('/refresh')
                    }else{
                      this.$message.error(response.data.msg)
                    }

                    
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })
            }
else{
   let alt='';
          if(type=='2')
          {
             alt=this.$i18n.t("msg.처리중하시겠습니까");
          }else if(type=='3')
          {
             alt=this.$i18n.t("msg.확인하시겠습니까");
          }
          this.$confirm(alt, this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.확인"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');
          this.btnLoad = true
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/money_up',
                       data:{
                       io_money:e.row.io_money,
                       status:type,
                       id:e.row.io_idx
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                    this.btnLoad = false
                    
                    if(response.data.code==200){
                      
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                       this.$router.replace('/refresh')
                    }else{
                      this.$message.error(response.data.msg)
                    }

                    
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })
}

         
            },

             okBtn(e){

            let idx=  this.io_idx
            console.log(idx)
            //return;
            

   
       
          let token=window.sessionStorage.getItem('user');
          this.infobtnLoad = true
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/money_up',
                       data:{
                       
                       status:'3',
                       id:idx
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                    this.infobtnLoad = false
                    
                    if(response.data.code==200){
                      
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                       this.$router.replace('/refresh')
                    }else{
                      this.$message.error(response.data.msg)
                    }

                    
    
                  }).catch((error) =>{
                      this.infobtnLoad = false
                      console.log(error)       //请求失败返回的数据
                  })
         
            },


    		changeOptions(e){

         // console.log(e);
               let token=window.sessionStorage.getItem('user');
               this.$axios({
                    method:'post',
                    url:this.domain+'/admin/money_up',
                    data:{
                       status:e.row.io_sangte,
                       old:0,
                       io_see:e.row.io_see,
                       id:e.row.io_idx
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                   console.log()
                   if(response.data.code==200)
                      {
                      	 this.$message({
		                      message:this.$i18n.t("msg.완료"),
		                      type: 'success'
		                    });

                         // this.getList();
                          this.$router.replace('/refresh')
                         
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
            },
    		  getVal(e){

          if(this.form.money=='')
          {
this.form.money='0';
          }

          if(e=='0')
          {
            this.form.money='0';
          }

          this.form.money=parseInt(this.form.money)+parseInt(e)
          console.log(e)
        },
    		
    	
    		
    	}
  }
</script>

 <style scoped>
 .bg-danger{
 	background-color:#72e8ff!important
 }
.bg-primary{
	background-color:#9dcdff!important
}
.bg-yellow {
    background-color: #f3ff77!important;
}
/deep/ .el-select-dropdown__item.selected{
	color:#000
}
/deep/ .el-input__inner{
	background:transparent;
	border:1px solid #cfcfcf;
	border-radius:2px;
}
/deep/ .el-dialog__body{
	padding:10px 20px;
}
/deep/ .el-form-item {
	margin-bottom:10px;
}

/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
 /deep/.typeIco .el-input__icon{
  line-height: 30px;
 }
 >>> .el-table__body tr.current-row > td {
    background-color: #d3d3d3!important;
  }
  .custom-dialog .el-dialog__body {
  max-height: 60vh; /* 视口高度的60% */
  min-height: 300px; /* 最小高度300px */
  overflow-y: auto; /* 超出时显示垂直滚动条 */
  padding: 20px;
}

/* 内容容器样式 */
.dialog-content {
  min-height: 150px; /* 确保内容区域有最小高度 */
}
</style>



// WEBPACK FOOTER //
// src/views/money/list.vue